import api from './api';

export interface IEbdDashboardSummaryResponse {
  period: {
    year: number;
    quarter: number;
  };
  summary: {
    totalChurches: number;
    totalRegisters: number;
    churchesWithRegister: number;
    churchesCoveragePercentage: number;
    averagePresencePercentage: number;
    activeLeaders: number;
    leadersWithRegister: number;
    leadersEngagementPercentage: number;
    averageClassesPerChurch: number;
  };
}

export interface IEbdDashboardChurchesRankingResponse {
  period: {
    year: number;
    quarter: number;
  };
  highest: {
    churchId: number;
    church: string;
    averagePresence: number;
    registers: number;
  }[];
  lowest: {
    churchId: number;
    church: string;
    averagePresence: number;
    registers: number;
  }[];
}

export interface IEbdDashboardLeadersRankingResponse {
  period: {
    year: number;
    quarter: number;
  };
  highest: {
    leaderId: number;
    leader: string;
    currentChurch: string;
    averagePresence: number;
    registers: number;
  }[];
  lowest: {
    leaderId: number;
    leader: string;
    currentChurch: string;
    averagePresence: number;
    registers: number;
  }[];
}

export interface IEbdDashboardClassesResponse {
  period: {
    year: number;
    quarter: number;
  };
  classesByAttendance: {
    name: string;
    value: number;
  }[];
  classesByChurchCoverage: {
    name: string;
    value: number;
  }[];
}

export interface IEbdDashboardTrendAlertsResponse {
  period: {
    year: number;
    quarter: number;
  };
  lessonTrend: {
    lesson: number;
    averagePresence: number;
    registers: number;
  }[];
  alerts: {
    type: 'warning' | 'danger' | 'info';
    title: string;
    description: string;
  }[];
  churchesWithoutRegister: string[];
}

class DashboardService {
  async getSummary(): Promise<IEbdDashboardSummaryResponse> {
    const response = await api.get<IEbdDashboardSummaryResponse>(
      '/bs/dashboard/ebd/summary',
    );

    return response.data;
  }

  async getChurchesRanking(): Promise<IEbdDashboardChurchesRankingResponse> {
    const response = await api.get<IEbdDashboardChurchesRankingResponse>(
      '/bs/dashboard/ebd/churches-ranking',
    );

    return response.data;
  }

  async getLeadersRanking(): Promise<IEbdDashboardLeadersRankingResponse> {
    const response = await api.get<IEbdDashboardLeadersRankingResponse>(
      '/bs/dashboard/ebd/leaders-ranking',
    );

    return response.data;
  }

  async getClassesMetrics(): Promise<IEbdDashboardClassesResponse> {
    const response = await api.get<IEbdDashboardClassesResponse>(
      '/bs/dashboard/ebd/classes',
    );

    return response.data;
  }

  async getTrendAlerts(): Promise<IEbdDashboardTrendAlertsResponse> {
    const response = await api.get<IEbdDashboardTrendAlertsResponse>(
      '/bs/dashboard/ebd/trend-alerts',
    );

    return response.data;
  }
}

export default new DashboardService();
